import { render, staticRenderFns } from "./IconSvgChair.vue?vue&type=template&id=0d662df5&scoped=true&"
import script from "./IconSvgChair.vue?vue&type=script&lang=js&"
export * from "./IconSvgChair.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d662df5",
  null
  
)

export default component.exports